import { type ValidateDocumentAdapter } from '../../validation/protocols/validate-document-adapter'

export class BirthdayValidatorAdapter implements ValidateDocumentAdapter {
  validate (birthday: string): boolean {
    if (birthday.length < 10) return false
    const birthdayDate = new Date(birthday)
    if (Number.isNaN(birthdayDate)) return false
    const today = new Date()
    today.setHours(0)
    today.setMinutes(0)
    today.setSeconds(0)
    today.setMilliseconds(0)
    birthdayDate.setFullYear(birthdayDate.getFullYear() + 18)
    return today >= birthdayDate
  }
}
